<template lang="pug">
  v-dialog(v-model='dialog' max-higth='500px' max-width='800' )
    template(v-slot:activator='{ on }' )
      v-row
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-btn(color='secondary' icon v-on='on' @click='get(idCotizacion); dialog=true')
              v-icon(small) fas fa-sticky-note
          span Ver cotización generada
    v-card( justify='center' max-width='800' )
        v-row.d-print-none
            v-col
                v-img(:src='Customers.logoUrl' max-height='200' max-width='300' align='right'  )
            v-spacer
            v-col(align='end')
                Boton_imprimir(nombre_de_impresion='Documento_de_cotizacion')
        v-container#Documento_de_cotizacion
            h1 Detalles de cotización enviada
            v-col
                p
                    span Cotizacion Nº :
                    span.grey--text.text--darken--4 {{Datos.numero_de_operacion}}
                p
                    span Fecha : 
                    span.grey--text.text--darken--4 {{Datos.creado_el}} 
                p  
                    span Titulo de cotizacion : 
                    span.grey--text.text--darken--4 {{Datos.titulo}}
                p 
                    span Mensaje adjuntado :  
                    span.grey--text.text--darken--4 {{Datos.mensaje}}
                span Fueron solicitados los siguientes productos :
            v-data-table(  :headers='headers' :items='Datos.items' item-key='key'  hide-default-footer align='center' )
            v-col   
                p Enviados a los provedores :
            v-data-table( :headers='headers_provedores' :items='Datos.provedores' hide-default-footer align='center')
            br 
            br 
            br
            p 
                span Atte:
                br
                span.grey--text.text--darken--4 {{Datos.creado_por}}
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
    
    data:()=>({
        dialog:false,
        dialog_print:false,
        headers:[
            {text:'Productos',  value:'descripcion'},
            {text:'Codigo',     value:'codigo'},
            {text:'Cantidad ',  value:'cantidad'},
            {text:'Unidad de medida',    value:'nombre_unidad_de_medida'},
        ],
        headers_provedores:[
            {text:'Nombre',     value:'name'},
            {text:'Documento',  value:'document'},
            {text:'Telefono',   value:'phone'},
            {text:'E-mail',     value:'email'},
        ],
        
    }),
    props:{
        idCotizacion : String,
    },
    methods:{
       
        ...mapActions({
            get: 'Cotizaciones/get_datos',
        })
    },
    computed: {
        ...mapState({
            Customers: state=>state.Customers.data,
            Datos: state=>state.Cotizaciones.datos,
        }),
    },
    components:{
        Boton_imprimir:()=>import ('@/components/boton_imprimir')
    }
}
</script>